import Joi from '@hapi/joi'

export const transactionSyncSchemaObject = {

    groupID: Joi.number().invalid(0).required().label("Group").messages({
        "any.invalid": `Group Required`,
        "any.required": `Group Required`
    }),
    operationEntityID: Joi.number().invalid(0).required().label("Estate").messages({
        "any.invalid": `Estate Required`,
        "any.required": `Estate Required`
    }),
    transactionTypeID:Joi.number().invalid(0).required().label("Transaction Type").messages({
        "any.invalid": `Transaction Type Required`,
        "any.required": `Transaction Type Required`
    }),
    divisionID: Joi.number().invalid(0).required().label("Division").messages({
        "any.invalid": `Division Required`,
        "any.required": `Division Required`
    }),
    date: Joi.string().invalid("").required().label("Date").messages({
        "any.invalid": `Please Select a Valid Date`,
        "any.required": `Date required`
    }),

    fromDate: Joi.string().invalid("").required().label("From Date").messages({
        "any.invalid": `Please Select a Valid Date`,
        "any.required": `From Date required`
    }),

    toDate: Joi.string().invalid("").required().label("To Date").messages({
        "any.invalid": `Please Select a Valid Date`,
        "any.required": `To Date required`
    }),
}














